import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserProDataSet } from 'src/app/shared/models/user-pro-data-set';
import { UserProDataSetProperty } from 'src/app/shared/models/user-pro-data-set-property';
import { ImportService } from 'src/app/shared/services/import.service';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';

@Component({
  selector: 'app-create-data-set-modal',
  templateUrl: './create-data-set-modal.component.html',
  styleUrls: ['./create-data-set-modal.component.scss']
})
export class CreateDataSetModalComponent implements OnInit {

  //all non super admin users - DATA SET CANNOT BE CREATED FOR SUPER ADMIN
  nonSuperAdminUsers: any[] = [];

  //list of property names
  partnerProProperties: string[];

  //list of all available properties - will include prop name and isSelected values
  selectableProperties: any[] = [];

  //the user we are creating the new data set for
  selectedUser: any;

  //represents the pro type we're selecting for
  selectedProType: string;

  //list of pro type options
  proTypes: string[] = [];

  newDataSet: UserProDataSet = new UserProDataSet();

  constructor(private importService: ImportService, private partnerService: PartnerService, private snackbarService: SnackBarService, public dialogRef: MatDialogRef<CreateDataSetModalComponent>) { }

  ngOnInit() {


    //get pro types
    this.proTypes = this.importService.importTypes;

    //get user accounts
    this.partnerService.getStaffAccounts().subscribe((x) => {

      //filter out super admins
      let userAccountsFiltered = x.results.filter(item => !item.groups.includes(1));

      //set global variable
      this.partnerService.setNonSuperAdminUsers(userAccountsFiltered);
    });

    //track non super admin accounts
    this.partnerService.nonSuperAdminUsers$.subscribe((x) => {
      this.nonSuperAdminUsers = x;
    });


    //get approved cat labels
    this.importService.getApprovedCatLabels().subscribe((x) => {
      this.importService.setApprovedCategoryLabels(x);
    })

    //track approved cat labels & create list of properties - default to not selected
    this.importService.approvedCatLabels$.subscribe((x) => {
      this.partnerProProperties = x;

      //clear values for resetting
      // this.selectableProperties = [];

      // this.partnerProProperties.forEach(prop => {

      //   let selectableProp = {
      //     isSelected: false, //default to not selected
      //     name: prop
      //   };

      //   this.selectableProperties.push(selectableProp);

      this.newDataSet.properties = [];

      this.partnerProProperties.forEach(prop => {
        let dataSetProperty = new UserProDataSetProperty();
        dataSetProperty.isRestricted = false;
        dataSetProperty.isSelected = true;
        dataSetProperty.propertyName = prop;

        this.newDataSet.properties.push(dataSetProperty);
      })
    })
  }

  onClose(): void {
    this.dialogRef.close();
  }

  //selects all properties for viewing
  selectAllProperties() {
    // this.selectableProperties.forEach(item => {
    //   item.isSelected = true;
    // })

    this.newDataSet.properties.forEach(item => {
      item.isRestricted = false;
    })
  }

  setPropertyRestriction(property: UserProDataSetProperty){
    property.isRestricted = !property.isRestricted;
  }

  //call api for data set
  createDataSet() {

    //TO DO: validate selected fields

    const formattedProperties = this.newDataSet.properties.map(prop => ({
      isSelected: prop.isSelected,
      name: prop.propertyName,
      isRestricted: prop.isRestricted
    }));

    this.partnerService.postDataSet(this.selectedUser.id, this.selectedProType, formattedProperties).subscribe(
      (response) => {
        // Handle success response
        console.log('Success:', response);
        this.snackbarService.showSnackBarMessage("Data Set successfully created!", "Close");

        this.onClose();
      },
      (error) => {
        // Handle error response
        console.error('Error:', error);

        this.snackbarService.showSnackBarMessage("An error occurred creating this Data Set.", "Close", undefined, true);
      }
    );

  }


}
